/*
 * @Description: 自定义事件id
 * @Author: xutao
 * @Date: 2020-12-08 15:26:49
 * @LastEditors: xutao
 * @LastEditTime: 2021-02-02 15:25:09
 */
export const CUSTOM_EVENT_ID = {
  /**
     * 根据shopid获取用户信息
     */
  GET_USER_INFO_BY_SHOPID: 'GET_USER_INFO_BY_SHOPID'
}
